import { throttle } from 'lodash-es';

import { escapeQuotes } from '../../utils/escape-quotes';

const TAB_LIST_DATA = 'c-tab-list-data';
const TAB_TYPE_SINGLE_VIDEO = 'single_video';
const TAB_TYPE_LIVE_VIDEO = 'live';
const TABS_NO_FE = 'c-tabs-video-no-fe';
const TABS_PRESS_THROTTLE_TIME = 200;
const TAB_VIDEO_PREFIX = 'tabVideo-';

const tabsList = document.querySelector(`#${TAB_LIST_DATA}`);
const tabsData = tabsList ? JSON.parse(tabsList.dataset.json) : { items: [] };
const filteredTabsData = [...tabsData.items].filter(
  (element) => element.tabType !== TAB_TYPE_SINGLE_VIDEO && element.tabType !== TAB_TYPE_LIVE_VIDEO
);

const tabTemplate = (tabTitle, tabData, tabIndex, index) => {
  const activeClass = index === 0 ? 'is-active' : '';
  return `
    <li class="c-tabs-video__item ${activeClass}" 
        data-json='${tabData}' 
        id="${TAB_VIDEO_PREFIX}${tabIndex}"
        aria-selected="${activeClass ? 'true' : 'false'}">
      <button type="button" class="c-tabs-video__link">
        ${tabTitle}
      </button>
    </li>
  `;
};

const tabTemplateNotFe = () => `<li class="c-tabs-video__item"></li>`;

export const getInitialTabsData = () => filteredTabsData.map((element, index) => ({ ...element, tabIndex: index }));

export const tabsRenderer = (tabsDataArray) => {
  if (tabsDataArray.length > 1) {
    tabsDataArray.forEach((element, index) => {
      tabsList.innerHTML += tabTemplate(
        element.tabTitle,
        JSON.stringify(element, escapeQuotes),
        element.tabIndex,
        index
      );
    });
  }
  if (tabsDataArray.length === 1) {
    tabsList.className = TABS_NO_FE;
    tabsList.innerHTML += tabTemplateNotFe();
  }
};

export const activeTab = (tabIndex) => {
  const tabsArray = document.querySelectorAll(`[id^="${TAB_VIDEO_PREFIX}"]`);
  tabsArray.forEach((tab, index) => {
    if (index === tabIndex) {
      tab.classList.add('is-active');
    } else {
      tab.classList.remove('is-active');
    }
  });
};

export const tabsClick = (callback) => {
  const tabsArray = document.querySelectorAll(`[id^="${TAB_VIDEO_PREFIX}"]`);
  if (tabsArray !== null && tabsArray !== undefined) {
    tabsArray.forEach((tab) => {
      tab.addEventListener(
        'click',
        throttle((event) => {
          if (event.currentTarget !== null) {
            tabsArray.forEach((li) => {
              li.classList.remove('is-active');
              li.setAttribute('aria-selected', 'false');
            });
            event.currentTarget.classList.add('is-active');
            event.currentTarget.setAttribute('aria-selected', 'true');
          }
          callback(tab);
        }, TABS_PRESS_THROTTLE_TIME)
      );
    });
  }
};
